export const FEATURE_FLAGS = {
  DASHBOARD: 'feat-dashboard',
  DSP_TENANT_ONBOARDING: 'feat-dsp-tenant-onboarding',
  FILE_IMPORT: 'feat-file-import',
  MANUAL_ORDER_CREATION: 'feat-manual-order-creation',
  SERVICE_KEYS_ENABLED: 'feat-service-keys-enabled',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
